import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import theme from '../../theme';

const ModalBody = (props) => {
  const {
    editMode,
    isLoading,
    inputErrorMsg,
    setInputErrorMsg,
    modalContent,
    modalData,
    setModalData,
    modalSecondData,
    setModalSecondData,
    handleModalSubmit,
    handleClose,
  } = props;

  switch (modalContent.render) {
    case 'default':
      return (
        <Box mt={2}>
          <Typography variant='h5'>{modalContent.content}</Typography>
          {
            modalContent.field &&
            <Typography variant='h5'
              sx={{
                mt: modalData[modalContent.field] ? 2 : 0,
                color: modalContent.mainColor
              }}>
              {modalData[modalContent.field]}
            </Typography>
          }
        </Box>
      )
    // case 'createCourse':
    //   return (
    //     <CreateCouseModal {...props} />
    //   )
    default:
      break;
  }
}


export default ModalBody;